/* tslint:disable */
/* eslint-disable */
/**
 * driverPortal fleet-registration api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 *
 * //!!!! WARNING !!!!!!!!
 * //This is an auto generated file.
 * //Changes to this code will be lost if the code is regenerated.
 */
import type { DriverPortalRegistrationRequiredTaxiLicencePerType } from './DriverPortalRegistrationRequiredTaxiLicencePerType';

export interface DriverPortalRegistrationFormFields {
    hide_referral_code: boolean;
    hide_taxi_license: boolean;
    hide_billing_type: boolean;
    hide_car_transport_licence_number: boolean;
    required_taxi_license: boolean;
    has_car_preselected: boolean;
    ask_for_fleet_matching: boolean;
    show_license_type_selection: boolean;
    required_taxi_license_per_type?: DriverPortalRegistrationRequiredTaxiLicencePerType;
}
